<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12V4H3.2V12H2ZM10.8 11.2L9.95 10.35L11.7 8.6H4.4V7.4H11.7L9.95 5.65L10.8 4.8L14 8L10.8 11.2Z"
      fill="#383838"
    />
  </svg>
</template>
